export default function ($http) {
    return function (dealerId) {
        return $http.get(`/api/dealers/statistics/${dealerId}`).then(result => result.data);
    };
}



// WEBPACK FOOTER //
// ./Client/app/dealer/services/detail/dealerStatistics.js